import { ITestCaseSchema } from '@/api/testCase';
import React from 'react';
import { useCustomSpec } from '@/utils/hooks/useCustomSpec';
import { ExtendedTableLowCode } from '@/components/shared/table/ExtendedTableLowCode';
import { HideCustomCreateButton } from '@/components/shared/button/HideCustomButtonCreate';

type StepDetailProps = {
  testCase: ITestCaseSchema;
};

export const StepDetail: React.FC<StepDetailProps> = ({ testCase }) => {
  const spec = useCustomSpec('/api/crud/step', {
    columns: [
      { key: 'title', label: 'Step Description' },
      { key: 'expected_result', label: 'Expected Result' },
    ],
  });

  return (
    <ExtendedTableLowCode
      spec={spec}
      defaultFilter={{ test_case_id: testCase.id }}
      customButtonCreate={HideCustomCreateButton}
      hideActionColumn
    />
  );
};
